import types from '../../config/types.js'
import ServerService from 'Services/ServerService.js'
import MockPagination from './MockPagination.js'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  mixins: [ServiceData, MockPagination],
  data() {
    return {
      serverPopup: {
        mode: types.serverModes.add,
        modelValue: {},
        opened: false,
      },
      serverService: ServerService,
      isSubmitting: false,
      serverDeleteConfirmOpened: false,
      pendingDeleteServerId: null,
    }
  },
  computed: {
    server() {
      return {
        host: 'hostmyhostingasap.com',
        proxy_host: 'hostmyhostingasap.com',
        login: 'логин',
        password: 'пароль',
        proxy_login: 'логин прокси сервера',
        proxy_password: 'пароль прокси сервера',
      }
    },
  },
  methods: {
    onDeleteServer(serverId) {
      this.pendingDeleteServerId = serverId
      this.serverDeleteConfirmOpened = true
    },
    onServerDeleteConfirmClose() {
      this.serverDeleteConfirmOpened = false
      this.pendingDeleteServerId = null
    },
    onServerDeleteConfirmApprove() {
      this.$store.dispatch('setIsLoading', true)
      this.serverService
        .removeServers([this.pendingDeleteServerId])
        .then(response => {
          if (response.data) {
            this.getServers({
              organizationId: this.currentOrganizationId,
            })
            this.serverDeleteConfirmOpened = false
            this.pendingDeleteServerId = null
            this.$store.dispatch('setIsLoading', false)
            this.$router.push({ name: 'Gates' })
          }
          this.serverPopup.opened = false
        })
        .catch(error => {
          this.serverDeleteConfirmOpened = false
          this.pendingDeleteServerId = null
          this.$store.dispatch('setIsLoading', false)
          this.$store.dispatch('setNotification', {
            text: 'Сперва удалите контроль доступа',
          })
          this.serverPopup.opened = false
        })
    },
    onAddServer() {
      this.serverPopup.mode = types.serverModes.add
      this.serverPopup.modelValue = {}
      this.serverPopup.opened = true
    },
    onEditServer() {
      this.serverPopup.mode = types.serverModes.edit
      this.serverPopup.modelValue = { ...this.server }
      this.serverPopup.opened = true
    },
    onServerPopupClose() {
      this.serverPopup.opened = false
      this.isSubmitting = false
    },

    onServerPopupApprove(serverData) {
      if (this.isSubmitting) {
        return
      }

      this.isSubmitting = true

      this.serverService
        .addServer({
          ouid: this.currentOrganizationId,
          host: serverData.host,
          proxy_host: serverData.proxy_host,
          stuid: serverData.stuid,
          login: serverData.login,
          password: serverData.password,
          proxy_login: serverData.proxy_login,
          proxy_password: serverData.proxy_password,
        })
        .then(response => {
          if (response.data) {
            this.getServers({
              organizationId: this.currentOrganizationId,
            })

            this.initPagination(
              this.serversMeta.current_page,
              this.serversMeta.total,
              this.serversMeta.per_page
            )
          }

          this.serverPopup.opened = false
        })
        .catch(error => {
          console.log(error)
          this.serverPopup.opened = false
        })
        .finally(() => {
          this.isSubmitting = false // Reset the flag
        })
    },

    onServerValidationFailed() {
      this.$store.dispatch('setNotification', {
        text: 'Заполните все поля',
        type: 'cross-outlined',
      })
    },
  },
}
